// src/pages/Redirect.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useSession } from '../context/SessionContext';

const Redirect: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useSession();

  useEffect(() => {
    if (!user) return;

    // Example role-based routing
    switch (user.role) {
      case 'Admin':
      case 'Support':
      case 'Client':
      case 'Client Plus':
      case 'Syndication Partner':
        navigate('/assets');
        break;
      case 'Billing':
        navigate('/billing');
        break;
      case 'Auditor':
        navigate('/assets');
        // navigate('/reporting');
        break;
      default:
        navigate('/not-authorized');
    }
  }, [user, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Redirect;
